<template>
    <div class="confirm-wrap">
        <div class="confirm-icon">
            <v-icon size="32" color="accent">mdi-email-outline</v-icon>
        </div>

        <h1 class="confirm-title">{{ $t('entrance.confirm_email') }}</h1>

        <p class="confirm-subtitle">{{ $t('entrance.step_for_confirm_email', { email: userEmail }) }}</p>

        <v-btn :disabled="cooldown > 0 || loading" :loading="loading" @click="resendVerification" block
            depressed color="primary" large class="black--text text-none font-weight-bold">
            <span v-if="cooldown === 0">{{ $t('entrance.resend_email') }}</span>
            <span v-else>{{ $t('entrance.resend_email_cooldown') }} {{ cooldown }}s</span>
        </v-btn>

        <logout-button outlined color="txtSecondary" large block class="mt-3" />
    </div>
</template>

<script>

import firebase from 'firebase/app'
import 'firebase/auth'
import LogoutButton from "@/components/common/inputs/LogoutButton"
import {sendVerificationEmail} from "@/utils/EmailVerification"

export default {
    components: { LogoutButton },
    data() {
        return {
            cooldown: 0,
            interval: null,
            loading: false
        }
    },
    computed: {
        userEmail(vm = this) {
            return vm.currentUser?.email || ''
        }
    },
    beforeDestroy() {
        this.clearTimer()
    },
    mounted() {
        this.startCooldown(30)
    },
    methods: {
        async resendVerification() {
            const user = firebase.auth().currentUser
            if (!user) return
            try {
                this.loading = true
                await sendVerificationEmail(this.$i18n.locale)
            } catch (error) {
                console.error('Error reenviando correo:', error)
                this.toast(this.$t('entrance.error_sending_email'), 'error')
            } finally {
                this.loading = false
                this.startCooldown(30)
            }
        },
        startCooldown(seconds) {
            this.cooldown = seconds
            this.interval = setInterval(() => {
                this.cooldown--
                if (this.cooldown <= 0) {
                    this.clearTimer()
                }
            }, 1000)
        },
        clearTimer() {
            if (this.interval) {
                clearInterval(this.interval)
                this.interval = null
            }
        }
    }
}
</script>

<style scoped>
.confirm-wrap {
    width: 100%;
    max-width: 380px;
    text-align: center;
}

.confirm-icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: rgba(51, 153, 153, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
}

.confirm-title {
    font-size: 22px;
    font-weight: 700;
    letter-spacing: -0.02em;
    margin-bottom: 10px;
}

.confirm-subtitle {
    font-size: 14px;
    color: var(--v-txtSecondary-base);
    line-height: 1.6;
    margin-bottom: 24px;
}
</style>